function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import './ToolbarHelp.css';
import cs from 'classnames';
import I18n from '../../I18n/I18n/I18n';
import QuestionMark from '../../Icons/QuestionMark/QuestionMark';
import whitelistProps from '../../utils/whitelistProps';
var whitelist = whitelistProps();
export default function ToolbarHelp(_ref) {
  var i18n = _ref.i18n,
    _ref$includeIcon = _ref.includeIcon,
    includeIcon = _ref$includeIcon === void 0 ? true : _ref$includeIcon,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_blank' : _ref$target,
    _ref$withHeader = _ref.withHeader,
    withHeader = _ref$withHeader === void 0 ? false : _ref$withHeader,
    url = _ref.url,
    attrs = _objectWithoutProperties(_ref, ["i18n", "includeIcon", "target", "withHeader", "url"]);
  return /*#__PURE__*/React.createElement("a", Object.assign({
    href: url,
    target: target,
    className: cs(['_dm-toolbar__button', '_dm-toolbar__button--help', {
      '_dm-toolbar__button--help__no-title': !withHeader
    }])
  }, whitelist(attrs)), /*#__PURE__*/React.createElement("span", {
    className: "_dm-toolbar__button-wrapper"
  }, /*#__PURE__*/React.createElement(QuestionMark, {
    className: "_dm-toolbar__help-icon",
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("span", {
    className: "_dm-toolbar__button-label"
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  }))));
}